'use client';

import { useConfigValue } from '@/components/providers/config-provider';
import { useEnvironmentUrl } from '@/hooks/use-environment-url';
import { useLocalizedConfig } from '@/hooks/use-localized-config';

export function useLocalizedConfigUrl({
  path,
  fallback,
}: {
  path: string;
  fallback?: string | null;
}): string {
  const localized = useLocalizedConfig<string>(path);
  const configValue = useConfigValue<string>(path);
  const { processUrl } = useEnvironmentUrl();
  return processUrl(localized || configValue || fallback || '');
}
